import EventBus from '../utils/EventBus.js'
import api from '../utils/api.ts'
import httpUtil from '../utils/httpUtil.js'
import md5 from '../utils/md5.js'
import rm from '../utils/rm.ts'
import util from '../utils/util.js'
import userUtils from './userUtils.ts'

/**
 * 获取订单详情
 */
function getOrderDetail(id, checkState, callback) {
  httpUtil.link(
    {
      apiName: 'orderdetails',
      orderId: id,
      checkPayStatus: checkState,
    },
    'GET',
    {},
    true,
    function (success, res, tips) {
      if (callback)
        callback(success, success ? res.data.Content : {}, tips)
    }
  )
}

/**
 * 支付订单
 */
function payOrder(param, callback) {
  // callback('error', {}, "支付失败")
  // if (!param.CustomerWxOpenIdObtained) {
  //   // userUtils.updateWxOpenId(function (success1, data, tips1) {
  //   //   console.log('更新openId:', success1, data, tips1)
  //   //   if (success1) {
  //   //     _checkPaymentParams(param, param.OrderInfo, callback)
  //   //   } else {
  //   //     callback('error', data, tips1)
  //   //   }
  //   // })
  // } else {
  //   _checkPaymentParams(param, param.OrderInfo, callback)
  // }
  _checkPaymentParams(param, param.OrderInfo, callback)
}

/**
 * 检查支付参数。
 */
function _checkPaymentParams(param, orderInfo, callback) {
  if (util.isEmpty(param.PaymentMethodSystemName)) {
    _getPayMethod(param.OrderId, function (success, orderData, tips0) {
      if (success) {
        var paymentMethod = orderData.data.Content.PaymentMethods[0].SystemName
        _pay(
          {
            OrderId: param.OrderId,
            PaymentMethodSystemName: paymentMethod,
          },
          orderInfo,
          callback
        )
      } else {
        callback('error', orderData, tips0)
      }
    })
  } else {
    _pay(
      {
        OrderId: param.OrderId,
        PaymentMethodSystemName: param.PaymentMethodSystemName,
      },
      orderInfo,
      callback
    )
  }
}

/**
 * 最终支付
 */
function _pay(payParam, orderInfo, callback) {
  httpUtil.link(
    'orderpay',
    'POST',
    payParam,
    true,
    function (success2, result, tips2) {
      console.log('支付参数:', success2, result, tips2)
      if (success2) {
        var info = result.data.Content;
        let resultParam = null;
        switch (payParam.PaymentMethodSystemName) {
          case "WechatPay":
            resultParam = {
              channel: "weixin",
              params: {
                appid: info.appid,
                partnerId: info.partnerid,
                prepayId: info.prepayid,
                packageValue: info.package,
                nonceStr: info.noncestr,
                timeStamp: info.timestamp,
                sign: info.sign
              }
            }
            break
          case "Alipay":
            resultParam = {
              channel: "alipay",
              params: info.Info,
            }
            break
        }
        console.log("resultParam", resultParam)
        if (resultParam) {

          rm.requestPayment(resultParam, function (payRes) {
            let success = false;
            let cancel = false;
            switch (payParam.PaymentMethodSystemName) {
              case "WechatPay":
                success = payRes.errCode === 0;
                cancel = payRes.errCode === -2;
                break
              case "Alipay":
                success = payRes.resultStatus === "9000";
                cancel = payRes.resultStatus === "6001";
                break
            }
            if (cancel) {
              // 用户取消付款
              var timeLeft = util.getLeftTimeHHMMArray(
                orderInfo.CreatedOn,
                orderInfo.AutoCloseUnpayedMinutes
              )
              var hour = timeLeft[0]
              var min = timeLeft[1]
              var timeLeftStr =
                (hour > 0 ? hour + '时' : '') + (min > 0 ? min + '分' : '')
              rm.showModal({
                title: '确认要取消支付？',
                content:
                  '您的订单在' +
                  timeLeftStr +
                  '内未支付将被取消，请尽快完成支付。',
                showCancel: true,
                cancelText: '取消支付',
                cancelColor: '#333333',
                confirmText: '继续支付',
                confirmColor: '#e74737',
              }, (modalRes) => {
                if (modalRes.cancel) {
                  // 取消支付
                  callback('cancel', modalRes, '取消支付')
                } else {
                  // 继续支付
                  _pay(payParam, orderInfo, callback)
                }
              })
            } else if (success) {
              // 支付成功
              callback('success', payRes, '订单支付成功')
              EventBus.send(EventBus.names.ORDER_STATE_CHANGE, {}, true)
            } else {
              // 支付失败
              callback('error', payRes, '支付失败')
            }
          })
        } else {
          callback('error', null, "不支持的支付方式")
        }
      } else {
        callback('error', result, tips2)
      }
    }
  )
}

/**
 * 根据订单ID获取支付方式列表
 */
function _getPayMethod(orderId, callback) {
  httpUtil.link(
    {
      apiName: 'orderprepay',
      orderId: orderId,
    },
    'GET',
    {},
    true,
    function (success, data, tips) {
      callback(success, data, tips)
    }
  )
}

/**
 * 取消订单
 */
function cancelOrder(orderId, callback) {
  httpUtil.link(
    {
      apiName: 'ordercancel',
      orderId: orderId,
    },
    'POST',
    {},
    true,
    function (success, data, tips) {
      callback(success, data, success ? '已取消订单' : tips)
      if (success) {
        EventBus.send(EventBus.names.ORDER_STATE_CHANGE, {}, true)
      }
    }
  )
}

/**
 * 确认订单
 */
function confirmOrder(orderId, callback) {
  httpUtil.link(
    {
      apiName: 'orderconfirm',
      orderId: orderId,
    },
    'POST',
    {},
    true,
    function (success, data, tips) {
      callback(success, data, success ? '已确认收货' : tips)
      if (success) {
        EventBus.send(EventBus.names.ORDER_STATE_CHANGE, {}, true)
      }
    }
  )
}

/**
 * 延遲收貨
 */
function delayAutoConfirm(orderId, callback) {
  httpUtil.link(
    {
      apiName: 'orderdelayautoconfirm',
      orderId: orderId,
    },
    'POST',
    {},
    true,
    function (success, data, tips) {
      callback(success, data, tips)
      if (success) {
        EventBus.send(EventBus.names.ORDER_STATE_CHANGE, {}, true)
      }
    }
  )
}

/**
 * 查看商品券码
 */
function viewExchangeCode(orderProductItemId) {
  var apiUrl =
    api.get('exchange') + '?orderItemId={orderItemId}&userhash=' + userUtils.getUserHash() + "&hidemenu=1";
  apiUrl = apiUrl.replace('{orderItemId}', orderProductItemId)
  apiUrl = apiUrl.replace('{userhash}', userUtils.getUserHash())
  util.navigateTo(apiUrl)
}

/**
 * 获取各状态订单数量
 */
function getOrderCount() {
  httpUtil.link(
    'getordercount',
    'GET',
    {},
    true,
    function (success, res, tips) {
      if (success) {
        var count = res.data.Content
        EventBus.send(EventBus.names.GET_ORDER_COUNT, {
          waitPay: count['10'] ? count['10'] : 0,
          waitShip: count['20'] ? count['20'] : 0,
          waitConfirm: count['30'] ? count['30'] : 0,
        }, true)
      }
    }
  )
}

/**
 * 获取售后选项和限制
 */
function getAfterSaleRule(orderItemId, callback) {
  httpUtil.link(
    {
      apiName: 'getreturnrequest',
      orderItemId: orderItemId,
    },
    'GET',
    {},
    true,
    function (success, res, tips) {
      callback(success, res, tips)
    }
  )
}

/**
 * 再次下单购买
 */
function reorder(orderId, callback) {
  httpUtil.link(
    {
      apiName: 'reorder',
      orderId: orderId,
    },
    'POST',
    {},
    true,
    function (success, data, tips) {
      callback(success, data, tips)
    }
  )
}
var PaidOrderCancelReasons = false

/**
 * 获取已支付订单退款申请理由
 */
function getPaidOrderCancelReasons(callback) {
  if (PaidOrderCancelReasons) {
    callback(true, PaidOrderCancelReasons, '获取成功')
  }
  httpUtil.link(
    {
      apiName: 'getcancelrequestreasons',
    },
    'GET',
    {},
    true,
    function (success, res, tips) {
      callback(success, res, tips)
      if (success && res.data.Content && res.data.Content.length > 0) {
        PaidOrderCancelReasons = res
      }
    }
  )
}

/**
 * 获取已支付订单退款申请理由
 */
function getPaidOrderCancelDetail(orderId, callback) {
  httpUtil.link(
    {
      apiName: 'ordercancelrequestdetail',
      orderId: orderId,
    },
    'GET',
    {},
    true,
    function (success, res, tips) {
      callback(success, res, tips)
    }
  )
}

/**
 * 已付款订单退款申请
 */
function orderPaidCancelRequest(info, callback) {
  httpUtil.link(
    {
      apiName: 'ordercancelpaid',
      orderId: info.orderId,
      comment: encodeURIComponent(info.comment),
    },
    'POST',
    {},
    true,
    function (success, data, tips) {
      callback(success, data, tips)
    }
  )
}

const orderManager = {
  getOrderDetail: getOrderDetail,
  payOrder: payOrder,
  cancelOrder: cancelOrder,
  viewExchangeCode: viewExchangeCode,
  confirmOrder: confirmOrder,
  getOrderCount: getOrderCount,
  delayAutoConfirm: delayAutoConfirm,
  getAfterSaleRule: getAfterSaleRule,
  reorder: reorder,
  _getPayMethod: _getPayMethod,
  _pay: _pay,
  getPaidOrderCancelReasons: getPaidOrderCancelReasons,
  getPaidOrderCancelDetail: getPaidOrderCancelDetail,
  orderPaidCancelRequest: orderPaidCancelRequest,
}


export default orderManager